import { Link } from "react-router-dom";
import { AiOutlineFilePdf } from "react-icons/ai";

export const config = (withFilter) => [
  {
    name: "Contrat",
    selector: (row) => row.contract_number,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Statut",
    sortable: true,
    filterable: withFilter,

    selector: (row) => row.status && row.status.title,
    conditionalCellStyles: [
      {
        when: (row) => row.status && row.status.type === "rejected",
        classNames: ["chip-component danger"],
      },
      {
        when: (row) => row.status && row.status.type === "validated",
        classNames: ["chip-component success"],
      },
      {
        when: (row) => row.status && row.status.type === "in_progress",
        classNames: ["chip-component warning"],
      },
      {
        when: (row) =>
          row.status && row.status.type === "additional_information",
        classNames: ["chip-component primary"],
      },
    ],
  },

  {
    name: "Date de création",
    selector: (row) => row.created_at,
    sortable: true,
    filterable: withFilter,
  },

  // {
  //   name: "Télécharger",
  //   selector: (row) => row.files && row.files,
  //   cell: (row) =>
  //     row.files && (
  //       <Link
  //         title="Télécharger le fichier"
  //         onClick={() => handleDownload("invoice", row.files)}
  //       >
  //         <AiOutlineFilePdf />
  //       </Link>
  //     ),
  // },

  {
    name: "Fichiers",
    selector: (row) => row.files && row.files,
    cell: (row) => (
      <>
        {row.files && (
          <Link to={row.files} target="_blank" download>
            <AiOutlineFilePdf />
          </Link>
        )}
      </>
    ),
  },
];
